<template>
  <div class="course-create-wrap">
    <a-form :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">游戏信息</div>
        <div class="info-content" style="padding-top:25px;padding-bottom:30px;">
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="游戏名称   "
              >
                <a-input
                  placeholder="请输入游戏名称"
                  v-decorator="[
                    'gameName',
                    {rules: [{ required: true, message: '请输入游戏名称' }]}
                  ]"
                />
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="游戏简介   "
              >
                <a-textarea
                  style="height:80px;resize: none;"
                  placeholder="请输入游戏简介"
                  v-decorator="[
                    'gameDesc',
                    {rules: [{ required: true, message: '请输入游戏简介' }]}
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:0px;position:relative;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="待选择图片   "
              >
                <a-table
                  :columns="columnsTop"
                  :bordered="ibordered"
                  :dataSource="sourceImgList"
                  size="small"
                  :pagination="ipagination"
                >
                  <!-- 词卡内容删除 -->
                  <span slot="action" slot-scope="text, record,index">
                    <a @click="delSourceImg(index)">删除</a>
                  </span>

                  <!-- 待选择图片 -->
                  <span slot="sourceImg" slot-scope="text,record,index" >
                    <a-form-item
                      :label-col="{ span: 0 }"
                      :wrapper-col="{ span: 24 }"
                      label=""
                      style="margin-bottom:0px;"
                    >
                      <a-upload
                        listType="picture-card"
                        class="teach-head-img"
                        :showUploadList="false"
                        :action="uploadAction"
                        :headers="headers"
                        :beforeUpload="imgBeforeUpload"
                        @change="value =>picBookImgChange(value,index,0)"
                        v-decorator="[
                      `sourceImgList[${index}].sourceImg`,
                      {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传待选择图片' }]},
                    ]"

                      >
                        <img v-if="sourceImgList[index].sourceImg" :src="sourceImgList[index].sourceImg"  style="width:100%;"/>
                        <div v-else>
                          <a-icon :type="sourceImgLoading[index] ? 'loading' : 'plus'" />
                          <div class="ant-upload-text"></div>
                        </div>
                      </a-upload>
                    </a-form-item>
                  </span>
                  

                  
                  <span slot="startAudio" slot-scope="text, record,index">
                    <a-form-item
                      :label-col="{ span: 0 }"
                      :wrapper-col="{ span: 24 }"
                      label="读题"
                      style="margin-bottom:0px;"
                    >
                      <a-upload
                        listType="picture-card"
                        class="teach-head-img"
                        :showUploadList="false"
                        :action="uploadAction"
                        :headers="headers"
                        :beforeUpload="audioBeforeUpload"
                        @change="value =>audioChange(value,4,index)"
                        v-decorator="[
                        `sourceImgList[${index}].startAudio`,
                        {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传语音' }]}]"
                      >
                        <span v-if="sourceImgList[index].startAudio">已上传</span>
                        <div v-else>
                          <a-icon :type="sourceStartAudioloading[index] ? 'loading' : 'plus'" />
                          <div class="ant-upload-text"></div>
                        </div>
                      </a-upload>
                    </a-form-item>

                  </span>
                  

                </a-table>
                <div class="j-teacher-add" style="margin-top:10px;">
                  <a-button
                  style="text-align:center;width:100%;line-height:34px;height:34px;font-size:14px;background-color:#F4F5F7;border-color:#D0DBE4;color:#BFC7CD;font-weight:bold;"
                  type="primary"
                  icon="plus"
                  @click="addSourceImgItem()">
                  </a-button>
                </div>
                <!-- <a-button @click="addPicBookItem()" type="primary" icon="plus" style="margin-left:8px;">新增词卡</a-button> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:0px;position:relative;margin-top:30px"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="待匹配图片   "
              >
                <a-table
                  :columns="columns"
                  :bordered="ibordered"
                  :dataSource="mateImgList"
                  size="small"
                  :pagination="ipagination"
                >
                  <!-- 词卡内容删除 -->
                  <span slot="action" slot-scope="text, record,index">
                    <a @click="delMateImg(index)">删除</a>
                  </span>

                  <!-- 第一张图片 -->
                  <span slot="mateImg" slot-scope="text,record,index" >
                    <a-form-item
                      :label-col="{ span: 0 }"
                      :wrapper-col="{ span: 24 }"
                      label=""
                      style="margin-bottom:0px;"
                    >
                      <a-upload
                        listType="picture-card"
                        class="teach-head-img"
                        :showUploadList="false"
                        :action="uploadAction"
                        :headers="headers"
                        :beforeUpload="imgBeforeUpload"
                        @change="value =>picBookImgChange(value,index,1)"
                        v-decorator="[
                      `mateImgList[${index}].mateImg`,
                      {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传待匹配图片' }]},
                    ]"

                      >
                        <img v-if="mateImgList[index].mateImg" :src="mateImgList[index].mateImg"  style="width:100%;"/>
                        <div v-else>
                          <a-icon :type="mateImgLoading[index] ? 'loading' : 'plus'" />
                          <div class="ant-upload-text"></div>
                        </div>
                      </a-upload>
                    </a-form-item>
                  </span>
                 
                  <span slot="startAudio" slot-scope="text, record,index">
                    <a-form-item
                      :label-col="{ span: 0 }"
                      :wrapper-col="{ span: 24 }"
                      label="读题"
                      style="margin-bottom:0px;"
                    >
                      <a-upload
                        listType="picture-card"
                        class="teach-head-img"
                        :showUploadList="false"
                        :action="uploadAction"
                        :headers="headers"
                        :beforeUpload="audioBeforeUpload"
                        @change="value =>audioChange(value,3,index)"
                        v-decorator="[
                        `mateImgList[${index}].startAudio`,
                        {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传语音' }]}]"
                      >
                        <span v-if="mateImgList[index].startAudio">已上传</span>
                        <div v-else>
                          <a-icon :type="mateStartAudioloading[index] ? 'loading' : 'plus'" />
                          <div class="ant-upload-text"></div>
                        </div>
                      </a-upload>
                    </a-form-item>

                  </span>
                  <span slot="correctImg" slot-scope="text,record,index">
                    <a-form-item
                      :label-col="{ span: 0 }"
                      :wrapper-col="{ span: 24 }"
                      label=""
                    >
                        <a-select v-decorator="[
                          `mateImgList[${index}].correctImg`,
                          {rules: [{ required: true, message: '请选择匹配的待选择图片'}]},
                        ]" placeholder="请选择正确的图片">
                          <a-select-option v-for="(item,i) in sourceImgList" :key="i" :value="i">待选择图片{{i+1}}</a-select-option>
                        </a-select>
                     </a-form-item>
                  </span>
                  

                </a-table>
                <div class="j-teacher-add" style="margin-top:10px;">
                  <a-button
                  style="text-align:center;width:100%;line-height:34px;height:34px;font-size:14px;background-color:#F4F5F7;border-color:#D0DBE4;color:#BFC7CD;font-weight:bold;"
                  type="primary"
                  icon="plus"
                  @click="addMateImgItem()">
                  
                  </a-button>
                </div>
                <!-- <a-button @click="addPicBookItem()" type="primary" icon="plus" style="margin-left:8px;">新增词卡</a-button> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col>
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="游戏音效   "
              >   
      
                <div class="voice-item">
                  <div class="voice-item-title">成功音效</div>
                  <div class="voice-item-media">
                    <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" label>
                      <a-upload
                        listType="picture-card"
                        class="teach-head-img"
                        :showUploadList="false"
                        :action="uploadAction"
                        :headers="headers"
                        :beforeUpload="audioBeforeUpload"
                        @change="value =>audioChange(value,0)"
                        v-decorator="[
                        'successAudio',
                        {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传语音' }]}]"
                      >
                        <span v-if="successAudio">已上传</span>
                        <div v-else>
                          <a-icon :type="successAudioloading ? 'loading' : 'plus'" />
                          <div class="ant-upload-text"></div>
                        </div>
                      </a-upload>
                    </a-form-item>
                  </div>
                </div>
                <div class="voice-item">
                  <div class="voice-item-title">失败音效</div>
                  <div class="voice-item-media">
                    <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" label>
                      <a-upload
                        listType="picture-card"
                        class="teach-head-img"
                        :showUploadList="false"
                        :action="uploadAction"
                        :headers="headers"
                        :beforeUpload="audioBeforeUpload"
                        @change="value =>audioChange(value,1)"
                        v-decorator="[
                        'failAudio',
                        {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传语音' }]}]"
                      >
                        <span v-if="failAudio">已上传</span>
                        <div v-else>
                          <a-icon :type="failAudioloading ? 'loading' : 'plus'" />
                          <div class="ant-upload-text"></div>
                        </div>
                      </a-upload>
                    </a-form-item>
                  </div>
                </div>
                <div class="voice-item">
                  <div class="voice-item-title">结束音效</div>
                  <div class="voice-item-media">
                    <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" label>
                      <a-upload
                        listType="picture-card"
                        class="teach-head-img"
                        :showUploadList="false"
                        :action="uploadAction"
                        :headers="headers"
                        :beforeUpload="audioBeforeUpload"
                        @change="value =>audioChange(value,2)"
                        v-decorator="[
                        'endAudio',
                        {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传语音' }]}]"
                      >
                        <span v-if="endAudio">已上传</span>
                        <div v-else>
                          <a-icon :type="endAudioloading ? 'loading' : 'plus'" />
                          <div class="ant-upload-text"></div>
                        </div>
                      </a-upload>
                    </a-form-item>
                  </div>
                </div>
              </a-form-item>
              
            </a-col>
          </a-row>
         
        </div>
      </a-card>
      <a-card
        :bordered="false"
        style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);"
      >
        <div class="a-row">
          <a-button
            style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
            type="primary"
            @click="saveGameData(0)"
          >保存</a-button>

           <a-button
            @click="saveGameData(1)"
            type="primary"
            style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;margin-left:15px;"
          >{{gameStatus=="0"?'发布':'取消发布'}}</a-button>
        </div>
      </a-card>
    </a-form>
  </div>
</template>

<script>

  import JEditor from '@/components/jeecg/JEditor'
  import Vue from 'vue'
  import { ACCESS_TOKEN ,TENANT_ID} from "@/store/mutation-types"

 import {getGameDetail,addGameData,updateGameData,onOrOffGame} from '@/api/api'   

  import pick from 'lodash.pick'

  import _ from 'lodash'
  import moment from 'moment'


  // import moment from 'moment'
  // import pick from 'lodash.pick'
  // import { FormTypes } from '@/utils/JEditableTableUtil'
  // import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  function getBase64 (img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }
  export default {
    name: 'DragGameCreate',
    components: { JEditor},
    mixins: [],
    data() {
      return {
        courseId:"",//编辑的时候的课程id
        chName:"", //课程名称
        chProfile:"",//课程简介
        picBookType:"",
      
        ibordered:true,
        ipagination:false,

        chapterList:[],
        columnsTop:[
          {
                title: '图片',
                dataIndex: 'sourceImg',
                scopedSlots: { customRender: 'sourceImg' },
                align:'center',
                width:90
            },
            {
                title: '读题音效',
                dataIndex: 'startAudio',
                align:'center',
                scopedSlots: { customRender: 'startAudio' },
                width:160
                
            },
            {
                title: '操作',
                dataIndex: '',
                scopedSlots: { customRender: 'action' },
                align:'center',
                width:60
            },
        ],
        columns:[
            {
                title: '待匹配图片',
                dataIndex: 'mateImg',
                scopedSlots: { customRender: 'mateImg' },
                align:'center',
                width:90
            },
            {
                title: '读题音效',
                dataIndex: 'startAudio',
                align:'center',
                scopedSlots: { customRender: 'startAudio' },
                width:160
                
            },
             {
                title: '正确的对应图片',
                dataIndex: 'correctImg',
                align:'center',
                scopedSlots: { customRender: 'correctImg' },
                width:160
                
            },
            {
                title: '操作',
                dataIndex: '',
                scopedSlots: { customRender: 'action' },
                align:'center',
                width:60
            },
        ],
        sourceImgList:[],
        mateImgList:[],
        failAudio:"",
        successAudio:"",
        endAudio:"",
        failAudioloading:false,
        successAudioloading:false,
        endAudioloading:false,
        
        gameStatus:false,

        
        sourceImgLoading:new Array(),
        mateImgLoading:new Array(),
        sourceStartAudioloading:new Array(),
        mateStartAudioloading:new Array(),

        getTypeValue:"0",//获取方式
        kaikeValue:"0",//
        kaikeStatus:"0",
        form: this.$form.createForm(this),
        loading: false,
        imageUrl: '',
        previewVisible: false,
        previewImage: '',
        fileList: [
        //   {
        //   uid: '-1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        // }
        ],
        url:{
          fileUpload: window._CONFIG['domianURL']+"/sys/common/upload",
        }
      }
    },
    
    methods: {

      normFile(e) {
        console.log('Upload event:', e);
        if (Array.isArray(e)) {
          return e;
        }
        return e && e.file.response && e.file.response.result.obsObjectUrl;
      },
      

      // 新增待选择图片
      addSourceImgItem(){
        this.sourceImgList.push({
          sourceImg:"",
          startAudio:""
        })
         this.sourceImgLoading.push(false)
         this.sourceStartAudioloading.push(false)
      },
      // 新增待匹配
      addMateImgItem(){
        this.mateImgList.push({
          mateImg:"",
          correctImg:"",
          startAudio:""
        })
        this.mateImgLoading.push(false)
        this.mateStartAudioloading.push(false)
      },
      


      // 删除待选择图片
      delSourceImg(index){
        this.sourceImgList.splice(index,1);
        this.sourceImgLoading.splice(index,1);
        this.sourceStartAudioloading.splice(index,1);
      },

      // 删除待匹配图片
      delMateImg(index){
        this.mateImgList.splice(index,1);
        this.mateImgLoading.splice(index,1);
        this.mateStartAudioloading.splice(index,1);
      },

      // wordImage 上传
      picBookImgChange(info,index,type){

        if (info.file.status === 'uploading') {
          if(type==0){
            this.sourceImgLoading[index] = true;
          }else{
            this.mateImgLoading[index] = true;
          }
          return
        }


        if(type==0){
          this.sourceImgList[index].sourceImg = info.file.response.result.obsObjectUrl;
        }else{
          this.mateImgList[index].mateImg = info.file.response.result.obsObjectUrl;
        }

        if (info.file.status === 'done') {
          if(type==0){
            this.sourceImgLoading[index] = false;
          }else{
            this.mateImgLoading[index] = false;
          }
          
        }
      },

      // 图片上传前校验
      imgBeforeUpload (file) {
        const isJPG = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.name);

        if(!isJPG){
          this.$message.error('只能上传图片!')
        }
       
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          this.$message.error('图片大小要小于5MB!')
        }
        return isJPG && isLt5M
      },

      // 音频上传前校验
    audioBeforeUpload(file) {
      const isJPG = /\.(mp3)$/.test(file.name);

      if (!isJPG) {
        this.$message.error("只能上传音频!");
      }

      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("图片大小要小于10MB!");
      }
      return isJPG && isLt10M;
    },
    audioChange(info, index,innum) {
      if (info.file.status === "uploading") {
        // this.teachloading = true
        if (index == 0) {
          this.successAudioloading = true;
        } else if(index == 1) {
          this.failAudioloading = true;
        }else if(index==2){
          this.endAudioloading = true;
        }else if(index==4){
          this.sourceStartAudioloading[innum] = true;
        }else if(index==3){
          this.mateStartAudioloading[innum] = true;
        }
        return;
      }

      // 0 成功 1 失败
      if (index == 0) {
        this.successAudio = info.file.response.result.obsObjectUrl;
        this.successAudioloading = false;
      } else if(index==1) {
        this.failAudio = info.file.response.result.obsObjectUrl;
        this.failAudioloading = false;
      } else if(index==2){
        this.endAudio = info.file.response.result.obsObjectUrl;
        this.endAudioloading = false;
      } else if(index==4){
        this.sourceImgList[innum]['startAudio']  = info.file.response.result.obsObjectUrl;
        this.sourceStartAudioloading = false;
      }
      else if(index==3){
        this.mateImgList[innum]['startAudio']  = info.file.response.result.obsObjectUrl;
        this.mateStartAudioloading = false;
      }
    },

     
      // 获取游戏数据
      getPageData(){
        let _this = this;
        getGameDetail({id:this.id}).then((res)=>{
          if(res.success==true){


            _this.gameContent = res.result.gameContent?JSON.parse(res.result.gameContent):{};
            _this.sourceImgList = _this.gameContent.sourceImgList || [];
            _this.mateImgList = _this.gameContent.mateImgList || [];

            _this.sourceStartAudioloading = new Array(_this.sourceImgList.length);
            _this.mateStartAudioloading = new Array(_this.sourceImgList.length);

            _this.successAudio = _this.gameContent.successAudio || "";
            _this.failAudio = _this.gameContent.failAudio || "";
            _this.endAudio = _this.gameContent.endAudio || "";

            _this.gameName = res.result.gameName;
            _this.gameDesc = res.result.gameDesc;

            _this.isTmpt = res.result.isTmpt;
            _this.gameStatus = res.result.gameStatus;//发布状态
            _this.gameType = res.result.gameType;

            this.form.setFieldsValue({'gameName':this.gameName})
            this.form.setFieldsValue({'gameDesc':this.gameDesc})
            this.form.setFieldsValue({'successAudio':this.successAudio})
            this.form.setFieldsValue({'failAudio':this.failAudio})
            this.form.setFieldsValue({'endAudio':this.endAudio})

            setTimeout(()=>{
              _.map(this.sourceImgList,(item,index)=>{
                this.form.setFieldsValue({
                    ["sourceImgList["+(()=>index)()+"].sourceImg"]:this.sourceImgList[index].sourceImg,
                    ["sourceImgList["+(()=>index)()+"].startAudio"]:this.sourceImgList[index].startAudio,
                  })
              })

              _.map(this.sourceImgList,(item,index)=>{
                this.form.setFieldsValue({
                    ["mateImgList["+(()=>index)()+"].mateImg"]:this.mateImgList[index].mateImg,
                    ["mateImgList["+(()=>index)()+"].correctImg"]:this.mateImgList[index].correctImg,
                    ["mateImgList["+(()=>index)()+"].startAudio"]:this.mateImgList[index].startAudio,
                  })
              })
            },500)
            
          }else{
            _this.$message.warning(res.message);
          }

        }).finally(() => {
          // that.confirmLoading = false;
          // that.checkedDepartNames = [];
          // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

          // that.close();
        })
      },

      // 保存游戏 0保存 1发布游戏
      saveGameData(type){
        let _this = this;

        this.form.validateFields((err, values) => {
          if (!err) {
            
            let {gameName,gameDesc,sourceImgList,mateImgList,successAudio,failAudio,endAudio} = values;
            let param = {gameName,gameDesc,"gameType":this.gameType,gameContent:JSON.stringify({mateImgList,sourceImgList,successAudio,failAudio,endAudio})}

            let apiName ;
            if(_this.isTmpt=="1"){
              apiName = addGameData(param)
            }else{
              param['id'] = this.id;
              apiName = updateGameData(param)
            }

            apiName.then((res)=>{
              if(res.success==true){

                
                _this.$message.success(res.message);

                //  
                if(type==0){
                  // 新建成功
                  // if(_this.isTmpt=="1"){
                    this.$router.push({ path:'/myCourse/myGameList'});
                  // }
                }else{  
                  // puter.push({ path:'/myGame/myGameList'});
                  _this.publishGame(res.result);   
                }
                
                
              }else{
                _this.$message.warning(res.message);
              }

            }).finally(() => {
              // that.confirmLoading = false;
              // that.checkedDepartNames = [];
              // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

              // that.close();
            })
          }
        })
      },
      // 发布游戏
      publishGame(id){
        let _this = this;
        onOrOffGame({id:id}).then((res)=>{
            if(res.success==true){
              if(_this.gameStatus==1){
                _this.$message.success("取消发布成功");
              }else{
                _this.$message.success("发布成功");
              }
              
              this.$router.push({ path:'/myCourse/myGameList'});
            }else{
              _this.$message.warning(res.message);
            }

          }).finally(() => {
            // that.confirmLoading = false;
            // that.checkedDepartNames = [];
            // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

            // that.close();
          })
      },
    },
    
    created () {
      const token = Vue.ls.get(ACCESS_TOKEN);
      let tenantid = Vue.ls.get(TENANT_ID)

      this.headers = {"X-Access-Token":token,"tenant_id":tenantid}

      this.id = this.$route.query.id;
      this.getPageData();
      
    },
    computed:{
      uploadAction:function () {
        return this.url.fileUpload;
      }
    },
  }
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
.course-create-wrap {
  .info-title {
    border-bottom: 1px solid #e7ecef;
    line-height: 50px;
    height: 50px;
    padding-left: 25px;
  }

  .info-content {
    .img-tip {
      color: #999999;
      font-size: 12px;
    }
    .ant-upload-list-picture-card {
      .ant-upload-list-item {
        width: 142px !important;
        height: 80px;
      }
    }
    .j-teacher-list {
      .j-teacher-item {
        .j-teacher-item-con {
          width: 587px;
          padding: 20px;
          overflow: hidden;
          border: 1px solid #d0dbe4;
          display: inline-block;
          vertical-align: middle;
          .j-teacher-item-upload {
            width: 90px;
            float: left;
            .ant-upload-select-picture-card {
              width: 80px;
              height: 80px;
            }
          }
          .j-teacher-item-ctx {
            margin-left: 90px;
          }
        }
        .j-teacher-item-cz {
          display: inline-block;
          vertical-align: middle;
          margin-left: 35px;
          color: #0091ff;
          cursor: pointer;
        }
      }
    }
    .kaike-tip {
      color: #fa6400;
      font-size: 12px;
      // line-height: 1;
    }
    .kaike-radio-list {
      line-height: 1;
      .kaike-radio-item {
        line-height: 1;
        margin-bottom: 12px;
        margin-top: 0px;
      }
    }
  }
  .voice-item {
    float: left;
    margin-right: 20px;
    .voice-item-title {
      text-align: center;
      padding: 5px 0px;
    }
  }
}
</style>